import { BrowserTypes } from 'react-device-detect';

export const APP_ENV = {
  DEV: 'dev',
  QA: 'qa',
  PROD: 'prod',
} as const;

export const BROWSER_SUPPORTED = [
  BrowserTypes.Chrome,
  BrowserTypes.Edge,
  BrowserTypes.EdgeChromium,
];

export const ANDROID_SUPPORTED_BROWSER = [BrowserTypes.Chrome];

export const IOS_SUPPORTED_BROWSER = [BrowserTypes.MobileSafari];

export const ENTER_KEY_CODE = 'Enter';

export const AUA_LANGUAGE_RESOURCE = 'AUA';

export const LANGUAGE_PREFIX = {
  COMMON: { keyPrefix: 'COMMON' },
  INMEETING: { keyPrefix: 'INMEETING' },
};

export const enum CALL_STATUS {
  CONNECTING = 'Connecting',
  IN_LOBBY = 'InLobby',
  CONNECTED = 'Connected',
  DISCONNECTING = 'Disconnecting',
  DISCONNECTED = 'Disconnected',
}

export const enum CAPTIONER_STATUS {
  CONNECTED = 'Connected',
  DISCONNECTED = 'Disconnected',
}

export const CALL_ADAPTER_STATE = {
  CONNECTED: 'Connected',
  PARTICIPANT_JOINED: 'participantsJoined',
  PARTICIPANT_LEFT: 'participantsLeft',
  IS_PARTICIPANT_MUTED_CHANGED: 'isMutedChanged',
  CALL_ENDED: 'callEnded',
  CALL_PARTICIPANT_LEFT: 'callParticipantsLeft',
} as const;

export const enum CONNECTION_STATUS {
  ONLINE = 'online',
  OFFLINE = 'offline',
}

export const enum FORM_FACTOR {
  MOBILE = 'mobile',
  DESKTOP = 'desktop',
}

export const enum SNACKBAR_TYPE {
  INFO = 'info',
  DANGER = 'danger',
  SUCCESS = 'success',
  WARNING = 'warning',
}

export const enum SNACKBAR_DURATION {
  SHORT = 1000,
  MEDIUM = 2000,
  LONG = 4000,
}

export const LANGUAGE_CAPTION_CODE = {
  ZH: 'zh',
  LZH: 'lzh',
} as const;

export const MESSAGE_FORMAT = {
  JSON: 'json',
  TEXT: 'text',
  BINARY: 'binary',
  PROTOBUF: 'protobuf',
} as const;

export const SERVER_MESSAGE = {
  NO_CAPTIONER: 'Captioner is disconnected',
  STOP_CAPTIONS: 'Stop Captions.',
  CAPTIONER_STATUS: 'Captioner Status.',
} as const;

export const SERVER_EVENT = {
  getCaptionerStatus: 'getCaptionerStatus',
};

export const SCROLL_BEHAVIOUR = 'smooth';

export const COPYRIGHT_TEXT = `© ${new Date().getFullYear()} Akouo Technologies Limited`;
export const APP_NAME = `Akouo Captions`;
